<template>
  <header-base>
    <div class="container">
      <div class="steps">
        <back-button
          v-if="stepsTaken.length > 1"
          @click="goBack"
        ></back-button>
        <step
          :step-index="stepsTaken.length - 1"
          :step="step"
        ></step>
        <finish
          v-if="isFinished"
          :key="'step_' + stepsTaken.length"
          :resultAmount="productAmount"
        ></finish>
      </div>
    </div>
  </header-base>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import HeaderBase from '@/components/layout/HeaderBase';
import Step from '@/components/library/Step';
import Finish from '@/components/library/Finish';
import BackButton from '@/components/layout/BackButton';

export default {
  name: 'StepHeaderMobile',

  components: {
    BackButton,
    Step,
    HeaderBase,
    Finish,
  },

  computed: {
    ...mapState('preference', [
      'stepsTaken',
    ]),
    ...mapGetters('preference', [
      'isFinished',
    ]),
    ...mapGetters('products', [
      'productAmount',
    ]),
    step() {
      // return 1
      return this.stepsTaken[this.stepsTaken.length - 1];
    },
  },

  methods: {
    goBack() {
      this.$store.dispatch('preference/goBackToStep', this.stepsTaken.length - 2);
    },
  },
};
</script>
